import T from 'libs/translate';

import { PRIVATE_LOGIN_STATE, PrivateLoginStateType } from '../constants/private_login';
import { getStorageAccessRequired } from './storageAccess';

type PrivateLoginText = {
  title: string;
  subtitle: string;
  buttonText: string;
};

export const getPrivateLoginText = (
  loginState: PrivateLoginStateType = PRIVATE_LOGIN_STATE.NOT_LOGGED_IN,
  sso = false,
): PrivateLoginText => {
  let text: PrivateLoginText = getStorageAccessRequired()
    ? {
        title: T.SignIntoVimeoToWatch,
        subtitle: T.YouMayNeedToAllowCookies,
        buttonText: sso ? T.SignInWithSSO : T.SignIn,
      }
    : {
        title: T.SignIntoVimeo,
        subtitle: T.PrivateVideo,
        buttonText: sso ? T.SignInWithSSO : T.SignIn,
      };

  switch (loginState) {
    case PRIVATE_LOGIN_STATE.LOGGED_IN_NOT_OWNER:
      text = {
        title: T.PrivateVideo,
        subtitle: T.SorryNoPermission,
        buttonText: '',
      };
      break;
    case PRIVATE_LOGIN_STATE.LOGGED_IN_STORAGE_ACCESS_REQUIRED:
      text = {
        title: T.AllowCookies,
        subtitle: T.YourBrowserWillAskToAllowCookies,

        buttonText: T.Continue,
      };
      break;

    case PRIVATE_LOGIN_STATE.STORAGE_ACCESS_GRANTED_LOGIN_UNCONFIRMED:
      text = {
        title: T.ContinueToSignIn,
        subtitle: T.YouMaySignInToWatch,
        buttonText: T.Continue,
      };
      break;

    case PRIVATE_LOGIN_STATE.ALL_ACCESS_ATTEMPTS_FAILED:
      text = {
        title: T.VideoUnavailable,
        subtitle: T.TryWatchingOnVimeo,
        buttonText: T.WatchOnVimeo,
      };
      break;
  }

  return text;
};
